export function showError(error) {
    console.error(error);
    let errEl = document.getElementById('error');
    errEl.textContent = errorToText(error);
    errEl.style.display = 'block';
    lockControls();
}

export function lockControls(ignoreSturdy=true) {
    for (let el of document.querySelectorAll('select, input, button, textarea')) {
        if (!ignoreSturdy || el.classList.contains('sturdy')) {
            continue;
        }
        el.disabled = true;
    }
}

function errorToText(err) {
    if (!err) {
        return `${err}`;
    }
    if (err.status && err.statusText && err.url) {
        return `Request to ${err.url} failed: ${err.status} ${err.statusText}`;
    }
    return err;
}
